/**
 * The KIND of party a provenance row names.
 *
 * VERA-931 added `Store`, and it is a genuinely different thing from the other
 * two rather than a third flavour of owner: a store is a place the item passed
 * THROUGH while the brand still owned it. Its row carries an address, not a
 * person, and it records custody rather than a change of ownership — which is
 * why it is sourced from `certificate_custody_events` and not from `transfers`.
 *
 * Consumers must branch on this rather than assuming a customer. The admin
 * aggregate hardcoded `Customer` on every row until VERA-931, which is exactly
 * the assumption a third member breaks.
 */
export enum ProvenanceHistoryItemType {
  Customer = 'customer',
  Company = 'company',
  Store = 'store',
}
